(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/internal/client/client-api-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/internal/client/client-api-utils.js');

'use strict';

const {
  productMapping
} = svs.numbergames;
function findProductBet(wager) {
  var _wager$bets, _wager$bets$find;
  return (_wager$bets = wager.bets) === null || _wager$bets === void 0 || (_wager$bets$find = _wager$bets.find) === null || _wager$bets$find === void 0 ? void 0 : _wager$bets$find.call(_wager$bets, bet => !productMapping.isJoker(bet.productId));
}
function getProduct(obj) {
  var _ref, _ref2, _ref3, _ref4, _obj$productItsId, _findProductBet;
  return (_ref = (_ref2 = (_ref3 = (_ref4 = (_obj$productItsId = obj.productItsId) !== null && _obj$productItsId !== void 0 ? _obj$productItsId : obj.productNumeric) !== null && _ref4 !== void 0 ? _ref4 : obj.productName) !== null && _ref3 !== void 0 ? _ref3 : obj.productId) !== null && _ref2 !== void 0 ? _ref2 : obj.product) !== null && _ref !== void 0 ? _ref : (_findProductBet = findProductBet(obj)) === null || _findProductBet === void 0 ? void 0 : _findProductBet.productId;
}


function getPrice(wager) {
  if (wager.betAmount) {
    return wager.betAmount;
  }
  if (wager.price) {
    return wager.price;
  }
  if (wager.totalPrice) {
    return parseInt(wager.totalPrice, 10);
  }
  if (Array.isArray(wager.bets)) {
    var _bet$betAmountSalesGr, _bet$betAmountSalesGr2;
    const bet = findProductBet(wager);
    return parseInt((_bet$betAmountSalesGr = bet === null || bet === void 0 ? void 0 : bet.betAmountSalesGroup1) !== null && _bet$betAmountSalesGr !== void 0 ? _bet$betAmountSalesGr : 0, 10) + parseInt((_bet$betAmountSalesGr2 = bet === null || bet === void 0 ? void 0 : bet.betAmountSalesGroup2) !== null && _bet$betAmountSalesGr2 !== void 0 ? _bet$betAmountSalesGr2 : 0, 10);
  }
  return 0;
}
function getDrawCount(wager) {
  if (wager.totalDrawCount) {
    return wager.totalDrawCount;
  }
  if (wager.drawCount) {
    return wager.drawCount === 'subscription' ? 1 : parseInt(wager.drawCount, 10);
  }
  if (Array.isArray(wager.bets)) {
    var _bet$numDraws;
    const bet = findProductBet(wager);
    return (_bet$numDraws = bet === null || bet === void 0 ? void 0 : bet.numDraws) !== null && _bet$numDraws !== void 0 ? _bet$numDraws : 0;
  }
  return 1;
}
function getBoards(wager) {
  if (Array.isArray(wager.boards)) {
    return wager.boards;
  }
  if (Array.isArray(wager.bets)) {
    var _ref5, _bet$lottoBoards;
    const bet = findProductBet(wager);
    const boards = (_ref5 = (_bet$lottoBoards = bet === null || bet === void 0 ? void 0 : bet.lottoBoards) !== null && _bet$lottoBoards !== void 0 ? _bet$lottoBoards : bet === null || bet === void 0 ? void 0 : bet.kenoBoards) !== null && _ref5 !== void 0 ? _ref5 : bet === null || bet === void 0 ? void 0 : bet.extNumberBoards;
    return boards === null || boards === void 0 ? void 0 : boards.map(board => {
      var _board$boardData;
      return {
        numbers: (_board$boardData = board.boardData) !== null && _board$boardData !== void 0 ? _board$boardData : board.boardData1,
        numbersExtra: board.boardData2
      };
    });
  }
}
function getRowCount(wager) {
  if (wager.rowCount) {
    return wager.rowCount;
  }
  if (Array.isArray(wager.boards) || Array.isArray(wager.bets)) {
    var _getBoards;
    const rules = svs.numbergames.rules.getRules(getProduct(wager));
    return (_getBoards = getBoards(wager)) === null || _getBoards === void 0 ? void 0 : _getBoards.reduce((acc, board) => {
      var _board$numbersExtra;
      return acc + svs.numbergames.rules.system.generatedRows({
        numbersLength: board.numbers.length,
        numbersRowSize: rules.numbersMaxLength,
        numbersExtraLength: (_board$numbersExtra = board.numbersExtra) === null || _board$numbersExtra === void 0 ? void 0 : _board$numbersExtra.length,
        numbersExtraRowSize: rules.numbersExtraMaxLength
      });
    }, 0);
  }
  return 0;
}
function getHasLotto2(wager) {
  if (!productMapping.isLotto(getProduct(wager))) {
    return false;
  }
  if (typeof wager.hasLotto2 === 'boolean') {
    return wager.hasLotto2;
  }
  if (Number.isInteger(wager.rowPriceMulti)) {
    return wager.rowPriceMulti === 2;
  }
  if (Array.isArray(wager.bets)) {
    var _bet$lottoBoards2;
    const bet = findProductBet(wager);
    return (bet === null || bet === void 0 || (_bet$lottoBoards2 = bet.lottoBoards) === null || _bet$lottoBoards2 === void 0 || (_bet$lottoBoards2 = _bet$lottoBoards2[0]) === null || _bet$lottoBoards2 === void 0 ? void 0 : _bet$lottoBoards2.participation) === 'L1L2';
  }
}
function getHasJoker(wager) {
  if (typeof wager.hasJoker === 'boolean') {
    return wager.hasJoker;
  }
  if (Number.isInteger(wager.jokerPrice)) {
    return Boolean(wager.jokerPrice);
  }
  if (Array.isArray(wager.bets)) {
    return Boolean(wager.bets.find(bet => productMapping.isJoker(bet.productId)));
  }
}
function getSelectedDays(wager) {
  const product = getProduct(wager);
  if (!productMapping.isProductFamily(product)) {
    return [productMapping.getProductItsId(product)];
  }
  if (Array.isArray(wager.selectedDays)) {
    return wager.selectedDays;
  }
  if (Array.isArray(wager.gameDays)) {
    return wager.gameDays;
  }
  return [];
}


function getDraws(draws, wager) {
  const drawCount = wager ? getDrawCount(wager) : 1;
  if (draws) {
    draws = Array.isArray(draws) ? draws : [draws];
    return draws.map(draw => {
      var _draw$drawNumber, _draw$drawCount;
      return {
        productItsId: productMapping.getProductItsId(getProduct(draw)),
        drawNumber: (_draw$drawNumber = draw.drawNumber) !== null && _draw$drawNumber !== void 0 ? _draw$drawNumber : draw.drawNum,
        drawCount: (_draw$drawCount = draw.drawCount) !== null && _draw$drawCount !== void 0 ? _draw$drawCount : drawCount
      };
    });
  }
}


function calculateKenoChances(wager) {
  const price = getPrice(wager);
  const drawCount = getDrawCount(wager);
  if (price && drawCount) {
    return price / drawCount / 5;
  }
  return 0;
}
function calculateLottoChances(wager) {
  const hasJoker = getHasJoker(wager);
  if (!hasJoker) {
    return 0;
  }
  const rowCount = getRowCount(wager);
  const hasLotto2 = getHasLotto2(wager);
  return rowCount * (hasLotto2 + 1);
}
function calculateIncludedDrawsCount(campaigns, draws) {
  return campaigns.reduce((includedDraws, campaign) => {
    campaign === null || campaign === void 0 || campaign.products.forEach(_ref6 => {
      var _draws$find;
      let {
        productId,
        startDrawNumber,
        endDrawNumber
      } = _ref6;
      const {
        drawNumber,
        drawCount
      } = (_draws$find = draws.find(draw => productMapping.isSameProduct(draw.productItsId, productId))) !== null && _draws$find !== void 0 ? _draws$find : {};
      for (let i = 0; i < drawCount; i++) {
        if (drawNumber + i >= startDrawNumber && drawNumber + i <= endDrawNumber) {
          includedDraws++;
        }
      }
    });
    return includedDraws;
  }, 0);
}
function calculateChances(_ref7, options) {
  let {
    campaigns
  } = _ref7;
  const {
    product,
    wager,
    draws
  } = options;
  if (!wager || !draws) {
    return;
  }
  let chancesPerDraw = 0;
  switch (productMapping.getProductId(product)) {
    case productMapping.CONSTANTS.KENO:
      chancesPerDraw = calculateKenoChances(wager);
      break;
    case productMapping.CONSTANTS.LOTTO:
      chancesPerDraw = calculateLottoChances(wager);
      break;
    default:
  }
  const selectedDays = getSelectedDays(wager);
  const selectedDraws = draws.filter(draw => selectedDays.find(product => productMapping.isSameProduct(draw.productItsId, product)));
  const includedDrawsCount = calculateIncludedDrawsCount(campaigns, selectedDraws);
  return chancesPerDraw * includedDrawsCount;
}
function calculateChancesWithoutCampaign(_ref8) {
  let {
    wager,
    drawCount
  } = _ref8;
  const product = getProduct(wager);
  if (!productMapping.isLotto(product)) {
    return;
  }
  const chancesPerDraw = calculateLottoChances(wager);
  const selectedDays = getSelectedDays(wager);
  drawCount !== null && drawCount !== void 0 ? drawCount : drawCount = getDrawCount(wager);
  return chancesPerDraw * drawCount * selectedDays.length;
}
svs.numbergames.campaign.internal.client_api_utils = {
  getDraws,
  calculateChances,
  calculateChancesWithoutCampaign
};

 })(window);